<div class="cache-management">
  <h1 class="cache-management__title">Управління кешем</h1>

  <mat-card class="cache-management__card">
    <mat-card-header>
      <mat-card-title>Очищення кешу сервісів</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="cache-management__buttons">
        @for (btn of cacheButtons; track btn.service + btn.key) {
          <button mat-raised-button color="accent" (click)="clearCache(btn.service, btn.key)">
            {{ btn.label }}
          </button>
        }
      </div>
    </mat-card-content>
  </mat-card>
</div>
